'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pickValidProps = require('react-utils/pickValidProps');

var _pickValidProps2 = _interopRequireDefault(_pickValidProps);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _Constants = require('./Constants');

var _compat = require('./lib/compat');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getStyles = function getStyles(size, rest) {
  return _extends({
    height: _Constants.AVATAR_SIZES[size],
    width: _Constants.AVATAR_SIZES[size],
    display: 'inline-block',
    textAlign: 'center'
  }, rest);
};

exports.default = _react2.default.createClass({
  displayName: 'UISimpleAvatar',

  propTypes: {
    className: _react.PropTypes.string,
    shape: _UIImage2.default.propTypes.shape,
    size: _react.PropTypes.oneOf(Object.keys(_Constants.SIZE_CLASSES)),
    src: _react.PropTypes.string.isRequired,
    style: _react.PropTypes.object
  },

  mixins: [_reactAddonsPureRenderMixin2.default],

  getDefaultProps: function getDefaultProps() {
    return {
      shape: 'circle',
      size: 'responsive'
    };
  },
  render: function render() {
    var _props = this.props,
        rawShapeProp = _props.shape,
        rawSizeProp = _props.size,
        src = _props.src,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['shape', 'size', 'src', 'style']);

    var transferableProps = (0, _pickValidProps2.default)(_UIImage2.default, rest);
    var shape = (0, _compat.computeShapeProp)(rawShapeProp);
    var size = (0, _compat.computeSizeProp)(rawSizeProp);

    return _react2.default.createElement(_UIImage2.default, _extends({}, transferableProps, {
      style: getStyles(size, style),
      responsive: size === 'responsive',
      shape: shape,
      src: src
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-1.1461/js/UISimpleAvatar.js
// module id = 87
// module chunks = 0